// import { LOGOS } from '@/config/logos';
// import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <div>
    {/* <footer className="bg-white border-t border-gray-200">
      <div className="px-4 sm:px-6 md:px-10 lg:px-20 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">

          <div className="sm:col-span-2 lg:col-span-1">
            <div className="text-2xl md:text-3xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif', color: '#2D5016' }}>
             <Link to="/" className="flex items-center space-x-3 group">
                                         <img 
                                           src={LOGOS.institut} 
                                           alt="Institut" 
                                           className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
                                         />
                                       </Link>
            </div>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed">
              Un groupe scolaire d'excellence offrant une éducation de qualité de la maternelle au lycée.
            </p>
          </div>
*
*

          <div>
            <h3 className="text-base md:text-lg font-semibold mb-4" style={{ color: '#2D5016' }}>
              Nos Établissements
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/institut" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Institut
                </Link>
              </li>
              <li>
                <Link to="/lycee-francais" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Lycée Français
                </Link>
              </li>
              <li>
                <Link to="/lycee-ivoirien" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Lycée Ivoirien
                </Link>
              </li>
              <li>
                <Link to="/maternelle-primaire" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Maternelle & Primaire
                </Link>
              </li>
            </ul>
          </div>


          <div>
            <h3 className="text-base md:text-lg font-semibold mb-4" style={{ color: '#2D5016' }}>
              Liens Rapides
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/a-propos" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/actualites/evenements" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Actualités
                </Link>
              </li>
              <li>
                <Link to="/inscription/frais" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Inscription
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm md:text-base text-gray-600 hover:text-[#2D5016] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>


          <div>
            <h3 className="text-base md:text-lg font-semibold mb-4" style={{ color: '#2D5016' }}>
              Contact
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg md:text-xl" style={{ color: '#2D5016' }}></i>
                <span className="text-sm md:text-base text-gray-600">Abidjan, Côte d'Ivoire</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-lg md:text-xl" style={{ color: '#2D5016' }}></i>
                <span className="text-sm md:text-base text-gray-600">+225 2722209272
                     <br/> +225 0709650928</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-lg md:text-xl" style={{ color: '#2D5016' }}></i>
                <span className="text-sm md:text-base text-gray-600 break-all">scolarite.fredetpoppee@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>


        <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs md:text-sm text-gray-600 text-center sm:text-left">
              © 2025 Groupe Scolaire Fred & Poppée. Tous droits réservés.
            </p>
            <a 
              href="#" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs md:text-sm text-gray-600 hover:text-[#2D5016] transition-colors whitespace-nowrap"
            >
              Designé par Fred & Poppée
            </a>
          </div>
        </div>
      </div>
    </footer> */}
    </div>
  );
}
